import { getLinkedInCampaignGoal, LINKEDIN_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/linkedin-utils';
import { useInitializeCompanyPage } from './use-initialize-company-page';

export const useInitializeWizard = () => {
  const campaignGoal = getLinkedInCampaignGoal();

  const urlParams = new URLSearchParams(window.location.search);
  const isReAuthOnly = urlParams.has('isReAuth') === true;

  // const isCompanyPageReady = false;
  const isMultiAdModel = false;
  const isAdStepActive = false;
  const {
    isCompanyPageInitialized,
    isCompanyPageReady,
    isFirstRun,
    isMemberTokenActive,
    permissionStatus,
    connectedCompanyPage,
  } = useInitializeCompanyPage();

  const initialStep = (isCompanyPageReady && isMemberTokenActive) ? LINKEDIN_WIZARD_STEP_PATHS.LINKEDIN_AD : LINKEDIN_WIZARD_STEP_PATHS.LI_COMPANY_PAGE_LINKING;

  const initialFlowFactors = {
    isCompanyPageReady,
    isMultiAdModel,
    isAdStepActive,
  };

  const initialWizardData = {
    campaignGoal,
    permissionStatus,
    connectedCompanyPage,
    isFirstRun,
    isMemberTokenActive,
    isReAuthOnly,
  };

  return {
    isInitialized: isCompanyPageInitialized,
    initialStep,
    initialFlowFactors,
    initialWizardData,
  };
};
